import { useNavigate } from "react-router-dom";
import type { GroupSummary } from "../../types";
import { getApi } from "../../api";
import { confirmAction, notify } from "../../store/uiStore";
import { reportError } from "../../services/eventBus";

/** Edit, Copy, and Delete handlers shared by the group grids. */
export function useGroupRowActions(onDeleted: (groupId: string) => void) {
  const navigate = useNavigate();

  const handleEdit = (group: GroupSummary) => navigate(`/uw/groups/${group.id}`);

  const handleCopy = (group: GroupSummary) => navigate(`/uw/groups/new?copyOf=${encodeURIComponent(group.id)}`);

  const handleDelete = async (group: GroupSummary) => {
    const confirmed = await confirmAction({
      title: "Delete group",
      message: `Delete ${group.name}? This removes all members and ratings.`,
      confirmLabel: "Delete",
      variant: "danger",
    });
    if (!confirmed) return;
    try {
      await getApi().deleteGroup(group.id);
      onDeleted(group.id);
      notify(`Deleted ${group.name}.`, "success");
    } catch (error) {
      reportError(error, "GroupRowActions.delete");
    }
  };

  return { handleEdit, handleCopy, handleDelete };
}
